// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce .easycommerce-new-customer-input {
    border: 1px solid var(--color-ec-border);
    border-radius: 6px;
    padding: 10px;
    color: var(--color-ec-body);
    height: 42px;
    background: #fff;
}
.easycommerce .easycommerce-new-customer-input:focus,
.easycommerce .easycommerce-new-customer-input:focus-visible {
    border: 1px solid var(--color-ec-primary);
    outline: none;
    box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Customers/style.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;AACpB;AACA;;IAEI,yCAAyC;IACzC,aAAa;IACb,gBAAgB;AACpB","sourcesContent":[".easycommerce .easycommerce-new-customer-input {\n    border: 1px solid var(--color-ec-border);\n    border-radius: 6px;\n    padding: 10px;\n    color: var(--color-ec-body);\n    height: 42px;\n    background: #fff;\n}\n.easycommerce .easycommerce-new-customer-input:focus,\n.easycommerce .easycommerce-new-customer-input:focus-visible {\n    border: 1px solid var(--color-ec-primary);\n    outline: none;\n    box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
